import React, {useEffect, useState} from 'react'
import {
  Button,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material'
import {useHistory, useParams} from 'react-router-dom'
import axios from 'axios'
import {BEHAVIOUR_ASSESSMENT_FORM_INPUTS} from '../BEHAVIOUR_CONSTANTS'
import {MoonLoader} from 'react-spinners'
import FormWrapper from '../../../../reusable-components/Wrapper/Wrapper'
import {Box} from '@mui/system'
import DynamicForm from '../../../../reusable-components/forms/DynamicForm'
import FrequencyDateRangePicker from '../../../../reusable-components/NoteType/NoteType'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../setup'
import AssessmentTypeSelect from '../../../../reusable-components/AssesmentType/AssesmentType'

const BehaviourNotesAssessmentEdit = () => {
  const {id}: {id: string} = useParams()
  const [formData, setFormData] = useState({})
  const [uiElements, setUiElements] = useState([])
  const [noteData, setNoteData] = useState<any>({
    noteType: '',
    assessmentType: '',
  })
  const [loading, setLoading] = useState(false)
  const [behaviorAssessment, setBehaviorAssessment] = useState<any>(null)
  const history = useHistory()
  const authUser = useSelector((state: RootState) => state.auth)
  useEffect(() => {
    const fetchClients = async () => {
      try {
        setLoading(true)
        const responseForNote = await axios.get(`/behavior-assessment/${id}`)
        const {behaviorAssessment} = responseForNote?.data
        // Store the original behavior assessment data
        setBehaviorAssessment(behaviorAssessment)
        const updatedclients = [
          ...behaviorAssessment?.clients?.map((client) => ({label: client.fullName, value: client._id})),
        ]

        const updatedFormData = BEHAVIOUR_ASSESSMENT_FORM_INPUTS.map((item) => {
          if (item.name === 'clientId') {
            return {...item, options: updatedclients, disabled: true, value: behaviorAssessment?.clientId}
          }
          return item
        })
        const updatedData = {
          clientId: behaviorAssessment?.clientId,
          behaviorsMapping: behaviorAssessment?.behaviorsMapping,
          initialTargetIds: behaviorAssessment?.initialTargetIds,
          initialReplacementIds: behaviorAssessment?.initialReplacementIds,
          initialTargetBehaviour: behaviorAssessment?.initialTargetBehaviour,
          initialReplacementBehaviour: behaviorAssessment?.initialReplacementBehaviour,
          type1: behaviorAssessment?.disability?.type1,
          type2: behaviorAssessment?.disability?.type2,
          type3: behaviorAssessment?.disability?.type3,
          name: behaviorAssessment?.planPreparedBy?.name,
          name1: behaviorAssessment?.keyContacts[0]?.name || '',
          relationship1: behaviorAssessment?.keyContacts[0]?.relationship || '',
          phoneNumber1: behaviorAssessment?.keyContacts[0]?.phoneNumber || '',
          name2: behaviorAssessment?.keyContacts[1]?.name || '',
          relationship2: behaviorAssessment?.keyContacts[1]?.relationship || '',
          phoneNumber2: behaviorAssessment?.keyContacts[1]?.phoneNumber || '',
          profession: behaviorAssessment?.planPreparedBy?.profession,
          registrationNumber: behaviorAssessment?.planPreparedBy?.registrationNumber,
          type: behaviorAssessment?.type,
          description: behaviorAssessment?.description,
          duration: behaviorAssessment?.duration,
          intensity: behaviorAssessment?.intensity,
          settingEvents: behaviorAssessment?.settingEvents,
          triggers: behaviorAssessment?.triggers,
          lowRiskScenarios: behaviorAssessment?.lowRiskScenarios,
          highRiskScenarios: behaviorAssessment?.highRiskScenarios,
          function: behaviorAssessment?.function,
          replacementBehaviour: behaviorAssessment?.replacementBehaviour,
          behaviouralGoals: behaviorAssessment?.behaviouralGoals,
          baselineAndPreventionLooksLike: behaviorAssessment?.baselineAndPrevention?.looksLike,
          baselineAndPreventionParticipantCanDo: behaviorAssessment?.baselineAndPrevention?.participantCanDo,
          baselineAndPreventionSupportTeamCanDo: behaviorAssessment?.baselineAndPrevention?.supportTeamCanDo,
          buildUpLooksLike: behaviorAssessment?.buildUp?.looksLike,
          buildUpParticipantCanDo: behaviorAssessment?.buildUp?.participantCanDo,
          buildUpSupportTeamCanDo: behaviorAssessment?.buildUp?.supportTeamCanDo,
          whenLooksLike: behaviorAssessment?.when?.looksLike,
          whenParticipantCanDo: behaviorAssessment?.when?.participantCanDo,
          whenSupportTeamCanDo: behaviorAssessment?.when?.supportTeamCanDo,
          formulation: behaviorAssessment?.formulation,
          preventativeStrategies: behaviorAssessment?.preventativeStrategies,
          skillBuildingStrategies: behaviorAssessment?.skillBuildingStrategies,
          reinforcementMotivation: behaviorAssessment?.reinforcementMotivation,
          planImplementationSystemSupports: behaviorAssessment?.planImplementationSystemSupports,
        }
        setFormData(updatedData)
       setNoteData({
          noteType: behaviorAssessment?.noteType,
          assessmentType: behaviorAssessment?.assessmentType || '', 
        })
        setUiElements(updatedFormData)
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchClients()
  }, [])

  const buttons = [
    {
      label: 'Cancel',
      variant: 'outlined',
      type: 'button',
    },
    {label: 'Save', variant: 'contained', type: 'submit'},
  ]

  const handleSubmitForm = async (formValues: any) => {
    // Remove the initial data arrays before submitting
    const {
      initialTargetBehaviour,
      initialReplacementBehaviour,
      initialTargetIds,
      initialReplacementIds,
      ...cleanFormValues
    } = formValues
    // Format behaviorsMapping with plain IDs
    if (cleanFormValues.behaviorsMapping && cleanFormValues.behaviorsMapping.length > 0) {
      cleanFormValues.behaviorsMapping = cleanFormValues.behaviorsMapping.map((behavior: any, index: number) => {
        // Extract just the IDs from the full objects
        const targetId = typeof behavior.targetId === 'object' ? behavior.targetId._id : behavior.targetId
        const replacementIds = Array.isArray(behavior.replacementIds) 
          ? behavior.replacementIds.map((replacement: any) => 
              typeof replacement === 'object' ? replacement._id : replacement
            )
          : behavior.replacementIds
        
        return {
          targetId,
          replacementIds,
        }
      })
    }
    
    if(formValues?.name1 && formValues?.relationship1 && formValues?.phoneNumber1){
      formValues.keyContacts = [
        {
          name: formValues.name1,
          relationship: formValues?.relationship1,
          phoneNumber: formValues?.phoneNumber1,
        }
      ]
    } 
    if(formValues?.name2 && formValues?.relationship2 && formValues?.phoneNumber2){
      formValues.keyContacts.push({
          name: formValues.name2,
          relationship: formValues?.relationship2,
          phoneNumber: formValues?.phoneNumber2,
        }
      )
    }

    const payload = {
      noteType: noteData.noteType,
       assessmentType: noteData.assessmentType,
      clientId: formValues.clientId,
      createdBy: authUser.user._id,
      behaviorsMapping: cleanFormValues.behaviorsMapping,
      keyContacts: formValues.keyContacts,
      disability: {
        type1: formValues.type1,
        type2: formValues.type2,
        type3: formValues.type3,
      },
      planPreparedBy: {
        name: formValues.name,
        profession: formValues.profession,
        registrationNumber: formValues.registrationNumber,
      },
      behaviourOfConcern: {
        type: formValues.type,
        description: formValues.description,
        duration: formValues.duration,
        intensity: formValues.intensity,
        settingEvents: formValues.settingEvents,
        triggers: formValues.triggers,
        lowRiskScenarios: formValues.lowRiskScenarios,
        highRiskScenarios: formValues.highRiskScenarios,
        function: formValues.function,
        replacementBehaviour: formValues.replacementBehaviour, 
        behaviouralGoals: formValues.behaviouralGoals,
      },
      baselineAndPrevention: {
        looksLike: formValues.baselineAndPreventionLooksLike,
        participantCanDo: formValues.baselineAndPreventionParticipantCanDo,
        supportTeamCanDo: formValues.baselineAndPreventionSupportTeamCanDo,
      },
      buildUp: {
        looksLike: formValues.buildUpLooksLike,
        participantCanDo: formValues.buildUpParticipantCanDo,
        supportTeamCanDo: formValues.buildUpSupportTeamCanDo,
      },
      when: {
        looksLike: formValues.whenLooksLike,
        participantCanDo: formValues.whenParticipantCanDo,
        supportTeamCanDo: formValues.whenSupportTeamCanDo,
      },
      formulation: formValues.formulation,
      preventativeStrategies: formValues.preventativeStrategies,
      skillBuildingStrategies: formValues.skillBuildingStrategies,
      reinforcementMotivation: formValues.reinforcementMotivation,
      planImplementationSystemSupports: formValues.planImplementationSystemSupports,
    }
    try {
      const response = await axios.put(`/behavior-assessment/${id}`, payload)
      if (response.status === 200) {
        toast.success('Behavior Assessment updated successfully')
        history.push('/notes/behavior-notes/list')
      }
    } catch (error) {
      toast.error('Error updating Behavior Assessment')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {loading ? (
        <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
          <MoonLoader color='#9db2fc' size={60} loading={loading} />
        </div>
      ) : (
        <FormWrapper
          title='Behavior Assessment'
          content={
            <>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  marginRight: '0.5rem',
                }}
              >
                <Button
                  variant='outlined'
                  color='primary'
                  onClick={() => history.goBack()}
                  sx={{marginRight: '10px', marginBottom: '10px'}}
                >
                  Back
                </Button>
              </Box>
              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: 'bold',
                  marginBottom: '0.5rem',
                  marginLeft: '1rem',
                }}
                color='primary'
              >
                Note Type
              </Typography>
               <Box sx={{ px: 2, mb: 2 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={6}>
                <FrequencyDateRangePicker
                  isEntry={false}
                  isTemplate={false}
                  isFullForm={false}
                  isEdit={true}
                  formData={noteData}
                  setFormData={setNoteData}
                />
              </Grid>

             <Grid item xs={12} sm={6}>
              <AssessmentTypeSelect
                value={noteData.assessmentType || ''}
                onChange={(value) =>
                  setNoteData((prev) => ({ 
                    ...prev, 
                    assessmentType: value 
                  }))
                }
              />
            </Grid>
              </Grid>
              </Box>
              <DynamicForm
                fields={uiElements}
                data={formData}
                onSubmit={handleSubmitForm}
                buttons={buttons}
                setFormValues={setFormData}
              />
            </>
          }
        />
      )}
    </>
  )
}

export default BehaviourNotesAssessmentEdit
